import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import Tooltip from "@ryangjchandler/alpine-tooltip";

Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(Tooltip);

window.Alpine = Alpine;
window.Alpine.start();
